import Clinic from "@/views/clinic/Clinic.vue"
import {cliniclist} from './cliniclist'
import {patientlist} from './patientlist'

export const clinic = {
  path: '/clinic',
  name: 'Clinic',
  component: Clinic,
  children:[
    patientlist,cliniclist
  ]
}


// WEBPACK FOOTER //
// ./src/router/index/clinic/index.js